import { render } from "./columnAmount.vue?vue&type=template&id=e1c02c1e&scoped=true&ts=true"
import script from "./columnAmount.vue?vue&type=script&lang=ts"
export * from "./columnAmount.vue?vue&type=script&lang=ts"

import "./columnAmount.vue?vue&type=style&index=0&id=e1c02c1e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e1c02c1e"]])

export default __exports__